module.exports = (category, action, label) => {
	if (gtag) {
		gtag("event", action, {
			event_category: category,
			event_label: JSON.stringify(label)
		});
	}
};
